import { first } from 'lodash';
import React, { useCallback, useEffect, useRef, useState, createRef } from 'react'
import StopWatch from './timer/stopwatch-component';
import { CSSTransition, TransitionGroup} from 'react-transition-group';
import { LoadingSpinner } from '../../global/components/loading-spinner';

//todo types and refactor into smaller components potentially pull timer into parent for reuse of time state in place like results

//init audio outside of react so that the audio itmes arent rerendered
const featured = new Audio('/Static/audio/correct-answer.mp3');
const wrong = new Audio('/Static/audio/feedback-incorrect.mp3');
const resultSound = new Audio('/Static/audio/crowd-cheers.mp3');

const AdvocacyQuizApp = ({questions , contentId } ) => {
    const [activeQuestion, setActiveQuestion] = useState(0);
    const [epiProps, setEpiProps] = useState(null);
    const [quizStart, setQuizStart] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const [audioOn, setAudioOn] = useState(false);
    const [soundOn, setSoundOn] = useState(true);
    const [themeLight, setThemeLight] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const [items, setItems] = useState(() => []);
    const [inAnswerResult, setInAnswerResult] = useState(false);
    const [timerOn, setTimerOn] = useState(false);
    const answerResultNodeRef = useRef(null);
    const resultNodeRef = useRef(null);
    const animationTiming = 400;

    const answersRef = useRef([]);
    const [numAnswersChecked, setNumAnswersChecked] = useState(0);

    const [questionAnswers, setQuestionAnswers] = useState({
        correct: 0,
        incorrect: 0
    });
    const [totalAnswers, setTotalAnswers] = useState({
        correct: 0,
        partiallyCorrect: 0,
        incorrect: 0
    });
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const [totalPossibleScore, setTotalPossibleScore] = useState(0);
    const [score, setScore] = useState(0);
    const [dataLayerContent, setDataLayerContent] = useState({
        questionNumber: 0,
        questionText: "",
        isCorrect: ""
    });
    useEffect(() => {
        fetch(`/api/v1/epi/properties?contentId=${contentId}`)
            .then(response => response.json())
            .then(setEpiProps);
    }, []);

    useEffect(() => {
        if (numAnswersChecked > 0) {
            setSubmitDisabled(false);
        } else {
            setSubmitDisabled(true);
        }
    }, [numAnswersChecked]);

    const htmlEncode = function (stringToEncode) {
        return { __html: stringToEncode };
    }

    function shuffleArray(arr) {
        var j, x, index;
        for (index = arr.length - 1; index > 0; index--) {
            j = Math.floor(Math.random() * (index + 1));
            x = arr[index];
            arr[index] = arr[j];
            arr[j] = x;
        }
        return arr;
    }
    const questionArray: any = Object.values(questions);
    const {pointValue, allowOneAnswer, wrongFeedback, correctFeedback, partiallyCorrectFeedback, answers} = questionArray[activeQuestion];
    const choices = [answers];
    const [choiceArray, setChoiceArray] = useState(shuffleArray(choices));

    useEffect(() => {
        setChoiceArray(shuffleArray(choices))
    }, [activeQuestion])

    const onClickStart = () => {
        setTotalPossibleScore(questionArray.length);
        if (quizStart) {
            quizReset();
        }
        else {
            setQuizStart(true);
            setTimerOn(true);
            setIsAnimating(true);
            setItems(() => [{
                questionContent: questionArray[0],
                nodeRef: createRef()
            }]);
            
          //  playAudio(bg);
        }
    }

    const quizReset = () => {
        setQuizStart(false);
        setActiveQuestion(0);
        setTimerOn(false);
        setShowResult(false);
        setTotalAnswers({
            correct: 0,
            partiallyCorrect: 0,
            incorrect: 0
        });
        setTotalPossibleScore(0);
        setScore(0);
    }

    const onChange = (event, isCorrect, currentQuestionNumber, question) => {
        if (allowOneAnswer) {
            setNumAnswersChecked(1);
            if (event.target.checked) {
                if (isCorrect === true) {
                    setQuestionAnswers(questionAnswers => ({ ...questionAnswers, correct: 1, incorrect: 0 }));
                } else {
                    setQuestionAnswers(questionAnswers => ({ ...questionAnswers, correct: 0, incorrect: 1 }));
                }
            }
        }
        else {
            if (event.target.checked) {
                setNumAnswersChecked(prev => prev + 1);
                if (isCorrect === true) {
                    setQuestionAnswers(questionAnswers => ({ ...questionAnswers, correct: questionAnswers.correct + 1 }));
                } else {
                    setQuestionAnswers(questionAnswers => ({ ...questionAnswers, incorrect: questionAnswers.incorrect + 1 }));
                }
            } else {
                setNumAnswersChecked(prev => prev - 1);
                if (isCorrect === true) {
                    setQuestionAnswers(questionAnswers => ({ ...questionAnswers, correct: questionAnswers.correct - 1 }));
                } else {
                    setQuestionAnswers(questionAnswers => ({ ...questionAnswers, incorrect: questionAnswers.incorrect - 1 }));
                }
            }
        }

        updateDataLayerObject(isCorrect, currentQuestionNumber, question);
    };

    const updateDataLayerObject = (isCorrect, currentQuestionNumber, question) => {
        let updatedContent = {
            questionNumber: currentQuestionNumber,
            questionText: question,
            isCorrect: isCorrect
        };
        setDataLayerContent(updatedContent);
    };

    const sendToGoogleAnalytics = () => {
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({
            'event': 'user_quiz_results',
            'question_number': dataLayerContent.questionNumber,
            'question_text': dataLayerContent.questionText,
            'answer': dataLayerContent.isCorrect ? 'correct' : 'incorrect',
            'quiz_name': epiProps.data.quizTitle
        });
    }

    const onClickSubmit = () => {
        sendToGoogleAnalytics();
        if (questionAnswers.correct === questionArray[activeQuestion].pointValue) {
            setTotalAnswers(totalAnswers => ({ ...totalAnswers, correct: totalAnswers.correct + 1 }));
        } else if (
            questionAnswers.correct > 0 &&
            questionAnswers.correct < questionArray[activeQuestion].pointValue
        ) {
            setTotalAnswers(totalAnswers => ({ ...totalAnswers, partiallyCorrect: totalAnswers.partiallyCorrect + 1 }));
        } else {
            setTotalAnswers(totalAnswers => ({ ...totalAnswers, incorrect: totalAnswers.incorrect + 1 }));
        }
        setInAnswerResult(true);
        setSubmitDisabled(true);
        questionAnswers.correct === pointValue && questionAnswers.incorrect === 0 ? playSound(featured) : playSound(wrong);
        answersRef.current.forEach((ref) => {
            if (ref) {
                ref.checked = false;
            }
        });
    }

    const onClickNext = () => {
        setQuestionAnswers({
            correct: 0,
            incorrect: 0
        });
        setTimerOn(true);
        setInAnswerResult(false);
        setNumAnswersChecked(0);
        if (activeQuestion !== questionArray.length - 1) {
            setItems(() => [{
                questionContent: questionArray[activeQuestion + 1],
                nodeRef: createRef()
            }]);
            setActiveQuestion((prev) => prev + 1);
        } else {
            if (totalAnswers.correct > 0) {
                setScore(totalAnswers.correct / totalPossibleScore);
            }
            setActiveQuestion(0);
            setItems(() => []);
            setTimerOn(false);
            setTimeout(() => {
                setShowResult(true);
                scrollIntoView();
                score > .8 ? playSound(resultSound) : null;
            }, animationTiming)
        }
    }

    const addLeadingZero = (number) => (number > 9 ? number : `0${number}`)

    const playSound = (sound) => {
        if (soundOn) {
            sound.volume = 0.5;
            sound.play(); // Play sound
        }
    }
    const playAudio = (sound) => {
        if (audioOn) {
            sound.loop = true;
            sound.volume = 0.3;
            sound.play(); // Play sound
        }
    }

   /* const onClickAudio = () => {
        setAudioOn(!audioOn);
        bg.volume = audioOn ? 0 : .3; 
    }*/
    const onClickSound = () => {
        setSoundOn(!soundOn);
    }

    const onClickTheme = () => {
        setThemeLight(!themeLight);
    }

    const scrollIntoView = () => {
        document.querySelector("[quiz-container]").scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    return (
        <div quiz-container="" className="quiz-container">
            <div className="options">
                <div className={themeLight? 'on options_sf' : 'on options_sf'} onClick={onClickTheme}>
                    <div className="visually-hidden">sound effect controls</div>
                    {themeLight ? <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M479.765 716Q538 716 579 675.235q41-40.764 41-99Q620 518 579.235 477q-40.764-41-99-41Q422 436 381 476.765q-41 40.764-41 99Q340 634 380.765 675q40.764 41 99 41Zm.235 60q-83 0-141.5-58.5T280 576q0-83 58.5-141.5T480 376q83 0 141.5 58.5T680 576q0 83-58.5 141.5T480 776ZM70 606q-12.75 0-21.375-8.675Q40 588.649 40 575.825 40 563 48.625 554.5T70 546h100q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5 0 12.825-8.625 21.325T170 606H70Zm720 0q-12.75 0-21.375-8.675-8.625-8.676-8.625-21.5 0-12.825 8.625-21.325T790 546h100q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5 0 12.825-8.625 21.325T890 606H790ZM479.825 296Q467 296 458.5 287.375T450 266V166q0-12.75 8.675-21.375 8.676-8.625 21.5-8.625 12.825 0 21.325 8.625T510 166v100q0 12.75-8.675 21.375-8.676 8.625-21.5 8.625Zm0 720q-12.825 0-21.325-8.62-8.5-8.63-8.5-21.38V886q0-12.75 8.675-21.375 8.676-8.625 21.5-8.625 12.825 0 21.325 8.625T510 886v100q0 12.75-8.675 21.38-8.676 8.62-21.5 8.62ZM240 378l-57-56q-9-9-8.629-21.603.37-12.604 8.526-21.5 8.896-8.897 21.5-8.897Q217 270 226 279l56 57q8 9 8 21t-8 20.5q-8 8.5-20.5 8.5t-21.5-8Zm494 495-56-57q-8-9-8-21.375T678.5 774q8.5-9 20.5-9t21 9l57 56q9 9 8.629 21.603-.37 12.604-8.526 21.5-8.896 8.897-21.5 8.897Q743 882 734 873Zm-56-495q-9-9-9-21t9-21l56-57q9-9 21.603-8.629 12.604.37 21.5 8.526 8.897 8.896 8.897 21.5Q786 313 777 322l-57 56q-8 8-20.364 8-12.363 0-21.636-8ZM182.897 873.103q-8.897-8.896-8.897-21.5Q174 839 183 830l57-56q8.8-9 20.9-9 12.1 0 20.709 9Q291 783 291 795t-9 21l-56 57q-9 9-21.603 8.629-12.604-.37-21.5-8.526ZM480 576Z" /></svg>
                        : <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M480 936q-150 0-255-105T120 576q0-150 105-255t255-105q8 0 17 .5t23 1.5q-36 32-56 79t-20 99q0 90 63 153t153 63q52 0 99-18.5t79-51.5q1 12 1.5 19.5t.5 14.5q0 150-105 255T480 936Zm0-60q109 0 190-67.5T771 650q-25 11-53.667 16.5Q688.667 672 660 672q-114.689 0-195.345-80.655Q384 510.689 384 396q0-24 5-51.5t18-62.5q-98 27-162.5 109.5T180 576q0 125 87.5 212.5T480 876Zm-4-297Z" /></svg>}
                </div>
                <div className={soundOn ? 'on options_sf' : 'off options_sf'} onClick={onClickSound}>
                    <div className="visually-hidden">sound effect controls</div>
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M560 925v-62q97-28 158.5-107.5T780 575q0-101-61-181T560 287v-62q124 28 202 125.5T840 575q0 127-78 224.5T560 925ZM120 696V456h160l200-200v640L280 696H120Zm420 48V407q55 17 87.5 64T660 576q0 57-33 104t-87 64ZM420 408 307 516H180v120h127l113 109V408Zm-94 168Z" /></svg>
                </div>
            </div>
            {(epiProps && epiProps.data.toggleTimer && (showResult || quizStart)) &&
                <StopWatch quizStarted={quizStart} timerOn={timerOn} />
            }
            {(!showResult && !quizStart) &&
                <div className="quiz-header">
                    <h1 className="quiz-header-title">{epiProps && epiProps.data.quizTitle}</h1>
                    <div className="quiz-header-intro" dangerouslySetInnerHTML={epiProps ? htmlEncode(epiProps.data.quizIntro) : null}></div>
                </div>
            }
            <div className={themeLight ? 'quiz adage-theme-light' : 'quiz adage-theme-dark'}>
                {!epiProps && <LoadingSpinner loading={true} />}
                {(!showResult && quizStart) &&
                    <div className="quiz-count">
                        <span className="active-question-no">
                            {addLeadingZero(activeQuestion + 1)}
                        </span>
                        <span className="total-question">
                            /{addLeadingZero(questionArray.length)}
                        </span>
                    </div>}
                
                <TransitionGroup component={null}>
                    {items.map(({ questionContent, nodeRef }) => (
                        <CSSTransition
                            key={questionContent.question}
                            nodeRef={nodeRef}
                            timeout={animationTiming}
                            classNames="fade"
                            unmountOnExit
                            >
                            <div className="quiz-question" ref={nodeRef }>
                                <h2>{questionContent.question}</h2>
                                {!allowOneAnswer && choiceArray[0].map((answer, index) => (
                                    <div className="quiz-input" key={index}>
                                        <input
                                            type="checkbox"
                                            ref={(el) => (answersRef.current[index] = el)}
                                            id={index}
                                            name={`answer-${index + 1}`}
                                            value={index}
                                            onChange={(event) =>
                                                onChange(
                                                    event,
                                                    answer.advocacyQuizAnswerCorrectness,
                                                    (activeQuestion + 1),
                                                    questionContent.question
                                                )
                                            }
                                        />
                                        <label
                                            htmlFor={index}
                                            dangerouslySetInnerHTML={htmlEncode(
                                                answer.advocacyQuizAnswer
                                            )}
                                        ></label>
                                    </div>
                                ))}
                                {allowOneAnswer && choiceArray[0].map((answer, index) => (
                                    <div className="quiz-input" key={index}>
                                        <input
                                            type="radio"
                                            ref={(el) => (answersRef.current[index] = el)}
                                            id={index}
                                            name="answer"
                                            value={index}
                                            onChange={(event) =>
                                                onChange(
                                                    event,
                                                    answer.advocacyQuizAnswerCorrectness,
                                                    (activeQuestion + 1),
                                                    questionContent.question
                                                )
                                            }
                                        />
                                        <label
                                            htmlFor={index}
                                            dangerouslySetInnerHTML={htmlEncode(
                                                answer.advocacyQuizAnswer
                                            )}
                                        ></label>
                                    </div>
                                ))}
                                </div>
                            </CSSTransition>
                    ))}
                </TransitionGroup>
                <CSSTransition
                    nodeRef={answerResultNodeRef}
                    in={inAnswerResult}
                    timeout={animationTiming}
                    classNames="scale"
                    unmountOnExit
                    //use this to automate the slide transition instead of two buttons onEntered={() => { setTimeout(onClickNext, 800) }}
                >
                <>
                   {!allowOneAnswer &&
                        <div ref={answerResultNodeRef} className={questionAnswers.correct === pointValue && questionAnswers.incorrect === 0 ? 'correct show-answer-result' : 'wrong show-answer-result'}>
                            {questionAnswers.correct === pointValue &&
                                questionAnswers.incorrect === 0 && <p className="correct-feedback" dangerouslySetInnerHTML={htmlEncode(correctFeedback)}></p>}

                            {questionAnswers.correct > 0 && questionAnswers.correct < pointValue && questionAnswers.incorrect === 0 &&
                                <p className="wrong-feedback" dangerouslySetInnerHTML={htmlEncode(partiallyCorrectFeedback)}></p>
                            }

                            {questionAnswers.correct > 0 && questionAnswers.incorrect > 0 &&
                                <p className="wrong-feedback" dangerouslySetInnerHTML={htmlEncode(partiallyCorrectFeedback)}></p>
                            }

                            {questionAnswers.correct === 0 && <p className="wrong-feedback" dangerouslySetInnerHTML={htmlEncode(wrongFeedback)}></p>}
                        </div>
                    }
                    {allowOneAnswer &&
                            <div ref={answerResultNodeRef} className={questionAnswers.correct === pointValue ? 'correct show-answer-result' : 'wrong show-answer-result'}>
                                {questionAnswers.correct === pointValue ? <p className="correct-feedback" dangerouslySetInnerHTML={htmlEncode(correctFeedback)}></p> : <p className="wrong-feedback" dangerouslySetInnerHTML={htmlEncode(wrongFeedback)}></p>}
                        </div>
                        }
                    </>
                </CSSTransition>

                {(!showResult && quizStart) &&
                    <div className="flex-right">
                        <button
                            onClick={onClickSubmit}
                            className={submitDisabled ? 'button-primary-disabled' : 'button-primary'}
                            disabled={submitDisabled}>
                            Submit
                        </button>
                        <button
                            onClick={onClickNext}
                            className={!inAnswerResult ? 'button-primary-disabled' : 'button-primary'}
                            disabled={!inAnswerResult}>
                            {activeQuestion === questionArray.length - 1 ? 'Finish' : 'Next'}
                        </button>
                    </div>}
                </div>
            <CSSTransition
                nodeRef={resultNodeRef}
                in={showResult}
                timeout={animationTiming}
                classNames="fade-up"
                unmountOnExit
            //use this to automate the slide transition instead of two buttons onEntered={() => { setTimeout(onClickNext, 800) }}
            >
                <div className="result-container" ref={resultNodeRef}>
                    <div className={themeLight ? 'adage-theme-light' : 'adage-theme-dark'}>
                        <div className="result">
                            <h2 className="result-title">Results</h2>
                        
                            {epiProps &&
                                <h2 className="result-subtitle">
                                    <span className="result-score"> {(score > .8) && epiProps.data.rankGood} {(score < .8 && score > .64) && epiProps.data.rankAverage} {(score <= .64) && epiProps.data.rankPoor}</span>
                                </h2>
                            }

                            <p className="result-subtitle">Correct Answers:<span className="result-score"> {totalAnswers.correct}</span></p>

                            <p className="result-subtitle">Partially Correct Answers:<span className="result-score"> {totalAnswers.partiallyCorrect}</span> </p>

                            <p className="result-subtitle">Wrong Answers:<span className="result-score"> {totalAnswers.incorrect}</span></p>
                        </div>
                    </div>

                    {(score > .8) && <div className="quiz-outro" dangerouslySetInnerHTML={epiProps ? htmlEncode(epiProps.data.quizOutroGood) : null}></div>}
                    {(score < .8 && score > .64) && <div className="quiz-outro" dangerouslySetInnerHTML={epiProps ? htmlEncode(epiProps.data.quizOutroAverage) : null}></div>}
                    {(score <= .64) && <div className="quiz-outro" dangerouslySetInnerHTML={epiProps ? htmlEncode(epiProps.data.quizOutroPoor) : null}></div>}

                    <div className="quiz-key">
                        {questionArray.map((item, index) => (
                            <div className="quiz-key-question" key={item.question}>
                                <p className="h3-styled">{index + 1}. {item.question}</p>
                                <ul>
                                    {item.answers
                                    .filter(
                                        (answer) => answer.advocacyQuizAnswerCorrectness === true
                                    )
                                    .map((answer) => (
                                        <li
                                            className="quiz-key-answer"
                                            key={answer.advocacyQuizAnswer}
                                            dangerouslySetInnerHTML={htmlEncode(
                                                answer.advocacyQuizAnswer
                                            )}
                                        ></li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                    </div>
                </CSSTransition>

            {((showResult || !quizStart) && epiProps) &&
                <button
                    onClick={onClickStart}
                    className="button-primary">
                    {!showResult ? 'Start' : 'Restart'}
                </button>
            }
        </div>
    )
}

export default AdvocacyQuizApp